import Logger from './logger.js';

class Texts {
    texts = null;
    constructor() {
        this.texts = window?.mscp?.texts || {};
    }

    getTextObj(key) {
        if (!this.texts) {
            Logger.debug("No texts found from server.");
            return { text: '', style: null }; // Return a default object with the key as text
        }
        if (!this.texts[key]) {
            Logger.debug("No text found for key %s", key);
            return { text: '', style: null }; // Return a default object with the key as text
        }
        return this.texts[key];
    }
}

const trans = new Texts();

const imageUrl = (key) => {
    const textObj = trans.getTextObj(key);
    return textObj.image || '';
};

const videoUrl = (key) => {
    const textObj = trans.getTextObj(key);
    return textObj.video || '';
};

const textObj = (key, args = null) => {
    let textObj = trans.getTextObj(key);

    if (args) {
        if (!Array.isArray(args)) {
            args = [args]; // Om det bara är ett argument, gör det till en array
        }
        args.forEach(arg => {
            textObj.text = textObj.text.replace('%s', arg);
        });
    }

    return textObj;
};

const getNumber = (key, defaultNumber = 1000) => {
    const textObject = textObj(key);
    const number = parseFloat(textObject.text);
    if (isNaN(number)) {
        Logger.log("No valid number found for key: %s. Using default number.", key);
        return defaultNumber;
    }
    return number;
};

const getBoolean = (key) => {
    const textObject = textObj(key);
    const true_false = Boolean(textObject.text);
    if (true_false === null) {
        // Logger.log("No valid checkbox found for key: %s. Using default checkbox.", key);
        return false;
    }
    return true_false;
};

const getColor = (key, defaultColor = '#000000') => {
    const textObject = textObj(key);
    const color = textObject.text;
    // Simple validation for hex color
    const isValidHex = /^#([0-9A-F]{3}){1,2}$/i.test(color);
    if (!isValidHex) {
        Logger.debug("No valid color found for key: %s. Using default color.", key);
        return defaultColor;
    }
    return color;
};
const textString = (key, defaultText = '') => {
    const textObject = textObj(key);
    return textObject.text || defaultText;
};

const textDiv = (wrapper, key, args = null) => {
    const textObject = textObj(key);
    const text = (textObject.text !== '') ? textObject.text : args?.defaultText || '';
    if (!text || text === '') {
        return false;
    }
    const div = document.createElement('div');
    div.id = `mscp-text-${key}`;
    div.classList.add('mscp-text-wrapper');
    if (args && args.additionalClasses) {
        args.additionalClasses.forEach(cls => div.classList.add(cls));
    }
    div.innerHTML = text;
    if (textObject.style) {
        div.classList.add(textObject.style);
    }
    wrapper.appendChild(div);
    return div;
};


const buttonString = (key, defaultText = '') => {
    // split line on : and wrap with <span> tags
    const textObject = textObj(key);
    if (!textObject.text || textObject.text === '') {
        if (defaultText === '') {
            Logger.debug("No text found for key: %s and no default text provided. Returning empty string.", key);
            return '';
        }
        Logger.log("No text found for key: %s. Using default text.", key);
        return `<span>${defaultText}</span>`;
    }
    // Split the text on ':' and wrap each part in a <span>
    const parts = textObject.text.split(':').map(part => `<span>${part.trim()}</span>`);
    // Join the parts back together
    const newText = parts.join('');
    // Return the modified text
    if (textObject.style) {
        return `<span class="${textObject.style}">${newText}</span>`;
    }
    // If no style is defined, return the text as is
    return newText || `<span>${defaultText}</span>`;
};

export { textObj, textDiv, imageUrl, videoUrl, textString, buttonString, getNumber, getBoolean, getColor };